export default ["2xs", "xs", "s", "m", "l", "xl", "2xl"];
